import type { PermitWorkflowTimeline } from "modules/permit"
import { WorkflowSimulationResultDialog } from "modules/permit/components/WorkflowSimulationResultDialog"
import { WorkflowApprovalDialogs } from "./WorkflowApprovalDialogs"
import { WorkflowTimelineDialog } from "./WorkflowTimelineDialog"

interface ApprovalDialogConfig {
  open: boolean
  isProcessing: boolean
  stageName: string
  note: string
  error?: string | null
  noteError?: string | null
  onNoteChange: (value: string) => void
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

interface WorkflowDialogsContainerProps {
  simulation: {
    open: boolean
    setOpen: (open: boolean) => void
    isLoading: boolean
    error: string | null
    result: any
  }
  approvalDialog: ApprovalDialogConfig
  rejectDialog: ApprovalDialogConfig
  requestReviewDialog?: ApprovalDialogConfig
  timeline: {
    open: boolean
    onOpenChange: (open: boolean) => void
    data: PermitWorkflowTimeline | null
    isLoading: boolean
    error: string | null
  }
}

export function WorkflowDialogsContainer({
  simulation,
  approvalDialog,
  rejectDialog,
  requestReviewDialog,
  timeline,
}: WorkflowDialogsContainerProps) {
  return (
    <>
      <WorkflowSimulationResultDialog
        open={simulation.open}
        onOpenChange={simulation.setOpen}
        isLoading={simulation.isLoading}
        error={simulation.error}
        result={simulation.result}
      />

      <WorkflowApprovalDialogs
        approveDialog={approvalDialog}
        rejectDialog={rejectDialog}
        requestReviewDialog={requestReviewDialog}
      />

      <WorkflowTimelineDialog
        open={timeline.open}
        onOpenChange={timeline.onOpenChange}
        timeline={timeline.data}
        isLoading={timeline.isLoading}
        error={timeline.error}
      />
    </>
  )
}
